// extracted by mini-css-extract-plugin
var _1 = "e7Ydl";
export { _1 as "config" }
